<div class="ma-dialog">

    <!-- Header -->
    <div class="ma-header">
        <div class="ma-header-icon">
            <mat-icon>admin_panel_settings</mat-icon>
        </div>
        <div class="ma-header-text">
            <h3 class="ma-title">Menu Access</h3>
            <p class="ma-subtitle">Configure permissions for each module</p>
        </div>
        <button mat-icon-button class="ma-close-btn" (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Loading -->
    <div mat-dialog-content *ngIf="menuLoading" class="ma-loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Loading permissions...</p>
    </div>

    <!-- Content -->
    <div mat-dialog-content *ngIf="!menuLoading" class="ma-content">

        <!-- Legend -->
        <div class="ma-legend">
            <span class="ma-legend-item view"><mat-icon>visibility</mat-icon> View</span>
            <span class="ma-legend-item edit"><mat-icon>edit</mat-icon> Edit</span>
            <span class="ma-legend-item delete"><mat-icon>delete_outline</mat-icon> Delete</span>
        </div>

        <!-- Employee Menu -->
        <div class="ma-section" style="--accent:#0ea5e9">
            <div class="ma-section-header">
                <div class="ma-section-icon"><mat-icon>badge</mat-icon></div>
                <span class="ma-section-label">Employee</span>
                <div class="ma-section-toggles">
                    <label class="ma-toggle-label view">
                        <mat-checkbox [checked]="isAllChecked(employeeSubmenuItems,'view')"
                            (change)="toggleAll(employeeSubmenuItems,'view',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label edit">
                        <mat-checkbox [checked]="isAllChecked(employeeSubmenuItems,'edit')"
                            (change)="toggleAll(employeeSubmenuItems,'edit',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label delete">
                        <mat-checkbox [checked]="isAllChecked(employeeSubmenuItems,'delete')"
                            (change)="toggleAll(employeeSubmenuItems,'delete',$event.checked)">All</mat-checkbox>
                    </label>
                </div>
            </div>
            <div class="ma-table-wrap">
                <table mat-table [dataSource]="employeeSubmenuItems" class="ma-table">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-menu">Menu</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-menu">
                            <div class="ma-menu-item"><mat-icon class="ma-menu-icon">{{item.icon}}</mat-icon><span>{{item.title}}</span></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm view">View</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.view" (change)="onViewChange(item)"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm edit">Edit</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.edit" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm delete">Delete</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.delete" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="ma-row"></tr>
                </table>
            </div>
        </div>

        <!-- Payroll & Expenses -->
        <div class="ma-section" style="--accent:#8b5cf6">
            <div class="ma-section-header">
                <div class="ma-section-icon"><mat-icon>payments</mat-icon></div>
                <span class="ma-section-label">Payroll &amp; Expenses</span>
                <div class="ma-section-toggles">
                    <label class="ma-toggle-label view">
                        <mat-checkbox [checked]="isAllChecked(payrollExpensesSubmenuItems,'view')"
                            (change)="toggleAll(payrollExpensesSubmenuItems,'view',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label edit">
                        <mat-checkbox [checked]="isAllChecked(payrollExpensesSubmenuItems,'edit')"
                            (change)="toggleAll(payrollExpensesSubmenuItems,'edit',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label delete">
                        <mat-checkbox [checked]="isAllChecked(payrollExpensesSubmenuItems,'delete')"
                            (change)="toggleAll(payrollExpensesSubmenuItems,'delete',$event.checked)">All</mat-checkbox>
                    </label>
                </div>
            </div>
            <div class="ma-table-wrap">
                <table mat-table [dataSource]="payrollExpensesSubmenuItems" class="ma-table">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-menu">Menu</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-menu">
                            <div class="ma-menu-item"><mat-icon class="ma-menu-icon">{{item.icon}}</mat-icon><span>{{item.title}}</span></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm view">View</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.view" (change)="onViewChange(item)"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm edit">Edit</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.edit" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm delete">Delete</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.delete" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="ma-row"></tr>
                </table>
            </div>
        </div>

        <!-- Payroll Setup -->
        <div class="ma-section" style="--accent:#f59e0b">
            <div class="ma-section-header">
                <div class="ma-section-icon"><mat-icon>settings</mat-icon></div>
                <span class="ma-section-label">Payroll Setup</span>
                <div class="ma-section-toggles">
                    <label class="ma-toggle-label view">
                        <mat-checkbox [checked]="isAllChecked(payrollSetupSubmenuItems,'view')"
                            (change)="toggleAll(payrollSetupSubmenuItems,'view',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label edit">
                        <mat-checkbox [checked]="isAllChecked(payrollSetupSubmenuItems,'edit')"
                            (change)="toggleAll(payrollSetupSubmenuItems,'edit',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label delete">
                        <mat-checkbox [checked]="isAllChecked(payrollSetupSubmenuItems,'delete')"
                            (change)="toggleAll(payrollSetupSubmenuItems,'delete',$event.checked)">All</mat-checkbox>
                    </label>
                </div>
            </div>
            <div class="ma-table-wrap">
                <table mat-table [dataSource]="payrollSetupSubmenuItems" class="ma-table">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-menu">Menu</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-menu">
                            <div class="ma-menu-item"><mat-icon class="ma-menu-icon">{{item.icon}}</mat-icon><span>{{item.title}}</span></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm view">View</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.view" (change)="onViewChange(item)"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm edit">Edit</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.edit" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm delete">Delete</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.delete" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="ma-row"></tr>
                </table>
            </div>
        </div>

        <!-- Reports -->
        <div class="ma-section" style="--accent:#10b981">
            <div class="ma-section-header">
                <div class="ma-section-icon"><mat-icon>summarize</mat-icon></div>
                <span class="ma-section-label">Reports</span>
                <div class="ma-section-toggles">
                    <label class="ma-toggle-label view">
                        <mat-checkbox [checked]="isAllChecked(reportsSubmenuItems,'view')"
                            (change)="toggleAll(reportsSubmenuItems,'view',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label edit">
                        <mat-checkbox [checked]="isAllChecked(reportsSubmenuItems,'edit')"
                            (change)="toggleAll(reportsSubmenuItems,'edit',$event.checked)">All</mat-checkbox>
                    </label>
                    <label class="ma-toggle-label delete">
                        <mat-checkbox [checked]="isAllChecked(reportsSubmenuItems,'delete')"
                            (change)="toggleAll(reportsSubmenuItems,'delete',$event.checked)">All</mat-checkbox>
                    </label>
                </div>
            </div>
            <div class="ma-table-wrap">
                <table mat-table [dataSource]="reportsSubmenuItems" class="ma-table">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-menu">Menu</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-menu">
                            <div class="ma-menu-item"><mat-icon class="ma-menu-icon">{{item.icon}}</mat-icon><span>{{item.title}}</span></div>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="view">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm view">View</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.view" (change)="onViewChange(item)"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm edit">Edit</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.edit" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef class="ma-col-perm delete">Delete</th>
                        <td mat-cell *matCellDef="let item" class="ma-col-perm">
                            <mat-checkbox [(ngModel)]="item.permissions.delete" [disabled]="!item.permissions.view||!item.allowEditDelete"></mat-checkbox>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="ma-row"></tr>
                </table>
            </div>
        </div>

    </div>

    <!-- Actions -->
    <div mat-dialog-actions class="ma-actions">
        <button mat-stroked-button class="ma-btn-cancel" (click)="onNoClick()">Cancel</button>
        <button mat-flat-button class="ma-btn-save" *ngIf="!isLoading" (click)="onConfirm()">
            <mat-icon>save</mat-icon> Save Changes
        </button>
        <button mat-flat-button class="ma-btn-save" *ngIf="isLoading" disabled>
            <span class="ma-spinner"></span> Saving...
        </button>
    </div>

</div>
